import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Divider,
  Modal,
  Button,
  TextField,
  FormControlLabel,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  AppBar,
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
} from "@mui/material";
import { IoMdClose } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import useSnack from "../../hooks/useSnack";

import useModal from "../../hooks/useModal";
import DeleteOrganization from "./DeleteOrganization";
import { setCookie } from "../../utilities/cookies";
import { useMediaQuery, useTheme as useThemee } from "@mui/material";
import { FaRegEdit } from "react-icons/fa";
import { RiDeleteBin6Line } from "react-icons/ri";

import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { BsPlusLg } from "react-icons/bs";
import { BsBell } from "react-icons/bs";
import { IoSettingsOutline } from "react-icons/io5";
import { useMenu } from "../../hooks/useMenu";
import ProfileMenuModal from "../../components/ProfileMenuModal";
import { useTheme } from "../../styles/theme";
import CardMembershipIcon from "@mui/icons-material/CardMembership";
import api from "../../utilities/axios";
import { useOrganization } from "../../hooks/useOrganization";

const EditIcon = () => <img src="/images/tabler_edit.png" alt="edit" />;
const DeleteIcon = () => <img src="/images/Vector.png" alt="delete" />;
const Dot = () => <img src="/images/proicons_more.png" alt="..." />;

const ListOrganization = () => {
  const navigate = useNavigate();
  const [organizations, setOrganizations] = useState([]);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [menuOrg, setMenuOrg] = useState(null);
  const [deleteOrg, setDeleteOrg] = useState(null);
  const { selectOrganization } = useOrganization();
  const { SnackBar, showMessage } = useSnack();
  const [editOrg, setEditOrg] = useState(null); // State for editing organization
  const { modalState, openModal, closeModal } = useModal();
  const [editModalState, setEditModalState] = useState(false); // Separate state for the edit modal
  const [anchorEl, setAnchorEl] = useState(null);
  const [isOpenDropdown, setIsOpenDropdown] = useState(false);
  const { toggleTheme, mode } = useTheme();
  const theme = useThemee();
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedOrg, setSelectedOrg] = useState(null);
  const platformUser = JSON.parse(localStorage.getItem("user"));
  const userId = platformUser?.id || platformUser?._id;

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  // const [theme, setTheme] = useState("system");
  let user = null;

  try {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      user = JSON.parse(storedUser);
    }
  } catch (error) {
    console.error("Error parsing user from localStorage", error);
  }
  const [image, setImage] = useState(user?.userImage || "");

  const getOrganizationList = async () => {
    try {
      const response = await api.get("/user/organizations", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("refreshToken")}`,
        },
        withCredentials: true, // Optional, if backend uses cookies
      });
      setOrganizations(response.data.organizations);

      if (response.data.organizations.length === 0) {
        navigate("/createOrganization");
      }
    } catch (err) {
      navigate("/createOrganization");
      console.error("Error fetching user:", err.response?.data || err.message);
    }
  };

  const handleDeleteClick = (org) => {
    setSelectedOrg(org);
    setOpenDialog(true);
  };

  const confirmDelete = async () => {
    if (!selectedOrg) return;

    try {
      await api.delete(`/user/organizations/delete/${selectedOrg._id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("refreshToken")}`,
        },
        withCredentials: true,
      });

      showMessage({ success: "Organization Deleted Successfully" });

      getOrganizationList();
      setOpenDialog(false);
    } catch (err) {
      console.error(
        "Error deleting organization:",
        err.response?.data || err.message
      );
    } finally {
      setOpenDialog(false);
      setSelectedOrg(null);
    }
  };

  const {
    anchorEl: anchorElProfile,
    openMenu: openProfileMenu,
    closeMenu: closeProfileMenu,
  } = useMenu();

  const {
    anchorEl: anchorElSettings,
    openMenu: openSettingsMenu,
    closeMenu: closeSettingsMenu,
  } = useMenu();
  // Handle Organization Selection
  async function handleSelect(org) {
    try {
      // Set the selected organization in context
      selectOrganization(org);

      // Show success message
      showMessage({ success: `Selected organization: ${org.name}` });

      // Navigate to dashboard
      navigate("/");
    } catch (error) {
      console.error("Error selecting organization:", error);
      showMessage({ error: "Failed to select organization" });
    }
  }

  useEffect(() => {
    getOrganizationList();
  }, []);

  const editClick = (org) => {
    navigate(`/EditOrganization`, { state: { org: org } });
  };

  const handleMenuOpen = (event, organization) => {
    setMenuAnchor(event.currentTarget);
    setMenuOrg(organization);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
    setMenuOrg(null);
  };

  return (
    <div className="min-h-screen flex flex-col">
      <AppBar position="static" sx={{ backgroundColor: "background.default" }}>
        <Toolbar
          className="flex justify-end items-center gap-6"
          sx={{ backgroundColor: "background.default" }}
        >
          <IconButton edge="end" className="md:hidden">
            <BsPlusLg
              onClick={() => {
                navigate("/createOrganization");
              }}
            />
          </IconButton>
          <IconButton
            edge="end"
            className="md:hidden"
            onClick={openSettingsMenu}
          >
            <IoSettingsOutline />
          </IconButton>
          <IconButton
            onClick={openProfileMenu}
            sx={{
              width: "45px",
              height: "45px",
              padding: 0,
              borderWidth: "2px",
              borderStyle: "solid",
              borderColor: "#3b84d9",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {platformUser.profilePicture ? (
              <img
                src={platformUser.profilePicture}
                alt="Profile"
                style={{
                  width: "100%",
                  height: "100%",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            ) : (
              <Typography
                variant="subtitle1"
                fontWeight={500}
                fontSize={14}
                sx={{
                  color: "#3b84d9",
                }}
              >
                {platformUser?.firstName && platformUser?.lastName
                  ? platformUser.firstName.charAt(0).toUpperCase() +
                  platformUser.lastName.charAt(0).toUpperCase()
                  : "?"}
              </Typography>
            )}
          </IconButton>
        </Toolbar>
        <Menu
          anchorEl={anchorElSettings}
          open={Boolean(anchorElSettings)}
          onClose={closeSettingsMenu}
        >
          <MenuItem onClick={toggleTheme}>
            <ListItemIcon>
              {mode === "dark" ? (
                <LightModeIcon fontSize="small" />
              ) : (
                <DarkModeIcon fontSize="small" />
              )}
            </ListItemIcon>
            Appearance
          </MenuItem>
        </Menu>

        <ProfileMenuModal
          anchorElProfile={anchorElProfile}
          closeProfileMenu={closeProfileMenu}
        />
      </AppBar>

      <Box
        sx={{
          backgroundColor: "background.default",
          paddingX: { xs: 3, sm: 5 },
          paddingY: 10,
        }}
      >
        <Box sx={{ paddingRight: { xs: 0, sm: 0 } }}>
          <div className="flex justify-between">
            <Typography variant="h4">Organization List</Typography>
          </div>
          <Typography
            sx={{
              marginTop: ".7rem",
              color: "text.secondary",
              fontSize: isMobile ? "13px" : "",
            }}
          >
            Organization refers to the style of coordination, communication and
            management, a team or an employee uses throughout his/her contract
            with the organization.
          </Typography>
          <Typography sx={{ marginTop: 5, color: "text.secondary" }}>
            Total Organizations
          </Typography>
          <Typography
            variant="h4"
            sx={{
              marginTop: ".2rem",
              marginBottom: 5,
              color: "text.secondary",
            }}
          >
            {organizations.length}
          </Typography>
        </Box>

        <Box sx={{ overflowX: "auto" }} className="text-center">
          <Grid container wrap="nowrap" sx={{ p: 1, minWidth: 1000 }}>
            <Grid item xs={2.5}>
              Organization
            </Grid>
            <Grid item xs={2.5}>
              Role
            </Grid>
            <Grid item xs={2.5}>
              Subscription
            </Grid>
            <Grid item xs={2.5}>
              Created At
            </Grid>
            <Grid item xs={0.5}>
              Action
            </Grid>
          </Grid>
          <Divider sx={{ minWidth: 1000, mb: 3 }} />
          <Box>
            {organizations.map((org) => {
              const member = org.members?.find(m => m.userId?.toString() === userId?.toString());
              const isOwnerOrAdmin = member ? ['owner', 'admin'].includes(member.role) : (org.userId === userId);
              const userRole = member ? member.role : 'owner';

              return (
                <Grid
                  key={org._id}
                  container
                  wrap="nowrap"
                  sx={{ p: 1, minWidth: 1200 }}
                >
                  <Grid
                    item
                    xs={2.5}
                    onClick={() => handleSelect(org)}
                    className="flex gap-3 cursor-pointer"
                  >
                    <Grid>
                      <Box
                        sx={{
                          position: "relative",
                          margin: "auto",
                          width: "35px",
                          height: "35px",
                          borderRadius: "50%",
                          overflow: "hidden",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: "background.view",
                          transition: "all 0.3s ease",
                          "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.6)" },
                        }}
                      >
                        <Typography
                          variant="subtitle1"
                          component="div"
                          fontWeight={600}
                          sx={{
                            fontSize: "20px",
                            fontFamily: "sans-serif",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            zIndex: 1,
                          }}
                        >
                          {org.name?.charAt(0).toUpperCase()}
                        </Typography>

                        {org.logo && (
                          <Box
                            component="img"
                            src={`${process.env.REACT_APP_SERVER}/static/${org.logo}`}
                            alt={org.name}
                            sx={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              zIndex: 2,
                            }}
                            onError={(e) => {
                              e.target.style.display = "none";
                            }}
                          />
                        )}
                      </Box>
                    </Grid>
                    <div className="px-3 py-1 truncate rounded-lg hover:text-sky-600 active:text-blue-600 capitalize cursor-pointer">
                      <span className="capitalize">{org.name}</span>
                    </div>
                  </Grid>
                  <Grid item xs={2.5}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        className={`p-1 rounded-[20px] flex items-center gap-2 ${mode === "dark"
                          ? userRole === 'owner' ? "bg-[#102a43]" : userRole === 'admin' ? "bg-[#102a43]" : "bg-[#1d3517]"
                          : userRole === 'owner' ? "bg-[#cce6ff]" : userRole === 'admin' ? "bg-[#cce6ff]" : "bg-[#d9f1d3]"
                          }`}
                        sx={{
                          color: mode === "dark" ? "white" : "black",
                          padding: "6px 12px",
                          borderRadius: "20px",
                          fontSize: 14,
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          width: "120px",
                          justifyContent: "center",
                          textTransform: "capitalize"
                        }}
                      >
                        <Box
                          component="span"
                          sx={{
                            width: "10px",
                            height: "10px",
                            borderRadius: "50%",
                            backgroundColor: userRole === 'owner' ? "#0080ff" : userRole === 'admin' ? "#0080ff" : "#52c41a",
                          }}
                        />
                        {userRole}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={2.5}>
                    {isOwnerOrAdmin ? (
                      <Typography
                        sx={{
                          textAlign: "center",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "10px",
                        }}
                      >
                        <CardMembershipIcon style={{ color: "#0080FF" }} />
                        Lite
                      </Typography>
                    ) : (
                      <Typography sx={{ color: "text.disabled", textAlign: "center" }}>-</Typography>
                    )}
                  </Grid>
                  <Grid item xs={2.5}>
                    {isOwnerOrAdmin ? (
                      <Typography sx={{ textAlign: "center" }}>
                        {new Date(org.createdAt).toLocaleDateString()}
                      </Typography>
                    ) : (
                      <Typography sx={{ color: "text.disabled", textAlign: "center" }}>-</Typography>
                    )}
                  </Grid>
                  <Grid item xs={0.5}>
                    {isOwnerOrAdmin ? (
                      <>
                        <Box sx={{ textAlign: "center" }}>
                          <IconButton onClick={(e) => handleMenuOpen(e, org)}>
                            <MoreVertIcon sx={{ transform: "rotate(90deg)" }} />
                          </IconButton>
                        </Box>

                        <Menu
                          anchorEl={menuAnchor}
                          open={Boolean(menuAnchor)}
                          onClose={handleMenuClose}
                        >
                          <MenuItem onClick={() => editClick(menuOrg)}>
                            <FaRegEdit className="mr-3" />
                            Edit
                          </MenuItem>
                          <MenuItem onClick={() => handleDeleteClick(menuOrg)}>
                            <RiDeleteBin6Line className="mr-3" />
                            Delete
                          </MenuItem>
                        </Menu>
                      </>
                    ) : (
                      <Box sx={{ textAlign: "center" }}>
                        <Typography sx={{ color: "text.disabled" }}>-</Typography>
                      </Box>
                    )}
                  </Grid>
                </Grid>
              );
            })}
          </Box>
        </Box>
        {SnackBar}
      </Box>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Are you sure?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            This action will permanently delete the organization. Do you want to
            continue?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
          <Button color="error" onClick={confirmDelete}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ListOrganization;
